import React from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import ReactTooltip from "react-tooltip"

import PrivateLayout from "components/Layout/PrivateLayout"
import { privateRoutes } from "router/routes"

import { bikeRegisteredEnum, useBikeRegistrationProcess } from "../hooks"
import { RegisterBikeForm } from "../components"
import { Seo } from "components/Seo"
import { useOperator } from "hooks"

export const RegisterBikePage: React.FC = () => {
	const { bikeRegistrationState } = useBikeRegistrationProcess()

	const bikeToSyncWithFnuci = bikeRegistrationState?.bike
	const bikeShouldBeSyncWithFnuci = !!bikeToSyncWithFnuci
	const bikeShouldBeRegistered = !bikeShouldBeSyncWithFnuci

	const navigate = useNavigate()
	const { t } = useTranslation()
	const { currentOperator } = useOperator()

	const isBikeRegistrationStep =
		bikeRegistrationState.step === bikeRegisteredEnum.bikeRegistrationStep

	React.useEffect(() => {
		// If user access to this page but isn't in BIKE_REGISTRATION_STEP
		// => we redirect to the dashboard
		if (!isBikeRegistrationStep) {
			navigate(privateRoutes.dashboard.path)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [bikeRegistrationState])

	return (
		<PrivateLayout>
			<Seo
				title={t("register_bike", {
					ns: "seo",
					operator: currentOperator.name,
				})}
			/>
			<div className="max-w-screen-lg mx-auto px-4 py-8 lg:py-16 relative">
				{/* Bike to update with FNUCI */}
				{bikeShouldBeSyncWithFnuci && (
					<>
						<h1 className="c-h1 leading-tight mb-4 md:mb-12">
							{t("update_bike", { ns: "bike" })}
						</h1>

						<div className="c-block py-10 px-6 md:px-6 xl:px-10 pt-12">
							<p className="text-s md:text-m text-center mb-6 max-w-lg mx-auto">
								{t("add_bike_page.update_description", {
									ns: "bike",
									bikeId: bikeRegistrationState.bikeId,
								})}
							</p>

							<RegisterBikeForm />
						</div>
					</>
				)}

				{/* Bike to register with FNUCI */}
				{bikeShouldBeRegistered && (
					<>
						<h1 className="c-h1 leading-tight mb-4 md:mb-12">
							{t("add_bike", { ns: "bike" })}
						</h1>

						<div className="c-block py-10 px-6 md:px-6 xl:px-10 pt-12">
							<p className="text-s md:text-m text-center mb-6 max-w-lg mx-auto">
								{t("add_bike_page.passport_description", {
									ns: "bike",
									operator: currentOperator.name,
								})}
							</p>

							<p className="text-s text-center pb-2">
								{t("add_modal.bike", { ns: "bike" })}
								<span className="font-bold pl-1">
									{bikeRegistrationState.bikeId}
								</span>
							</p>

							<RegisterBikeForm />
						</div>
					</>
				)}
			</div>
			<ReactTooltip backgroundColor={"var(--primaryColor)"} />
		</PrivateLayout>
	)
}
